export default "__VITE_ASSET__4d5bae28__"